import React from 'react';
import { Card, Row, Col, Statistic, Typography } from 'antd';
import {
  DashboardOutlined,
  DollarOutlined,
  ShoppingOutlined,
  ToolOutlined,
  RiseOutlined,
  FallOutlined,
} from '@ant-design/icons';

const { Title, Paragraph } = Typography;

const ExecutiveDashboard: React.FC = () => {
  return (
    <div>
      <Title level={2}>
        <DashboardOutlined /> Company KPI Dashboard
      </Title>
      <Paragraph>Executive-level view of company-wide key performance indicators.</Paragraph>

      <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Revenue (MTD)"
              value={2450020}
              precision={2}
              prefix={<DollarOutlined />}
              suffix={<RiseOutlined style={{ color: '#3f8600', fontSize: 14 }} />}
              valueStyle={{ color: '#3f8600' }}
            />
            <div style={{ fontSize: 12, color: '#8c8c8c', marginTop: 8 }}>
              +12.5% vs last month
            </div>
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Customer Orders"
              value={156}
              prefix={<ShoppingOutlined />}
              valueStyle={{ color: '#145A54' }}
            />
            <div style={{ fontSize: 12, color: '#8c8c8c', marginTop: 8 }}>
              +8 new orders this week
            </div>
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Production Efficiency"
              value={87.5}
              precision={1}
              suffix="%"
              prefix={<ToolOutlined />}
              valueStyle={{ color: '#faad14' }}
            />
            <div style={{ fontSize: 12, color: '#8c8c8c', marginTop: 8 }}>
              Target: 90%
            </div>
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Quality Rating"
              value={95.2}
              precision={1}
              suffix="%"
              valueStyle={{ color: '#52c41a' }}
            />
            <div style={{ fontSize: 12, color: '#8c8c8c', marginTop: 8 }}>
              Excellent performance
            </div>
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
        <Col xs={24} lg={12}>
          <Card title="Revenue Trend (Last 6 Months)" bordered={false}>
            <Paragraph>Revenue trend chart would appear here.</Paragraph>
          </Card>
        </Col>
        <Col xs={24} lg={12}>
          <Card title="Top Performing Products" bordered={false}>
            <Paragraph>Product performance data would appear here.</Paragraph>
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card title="Department Performance" bordered={false}>
            <Paragraph>Departmental KPIs would appear here.</Paragraph>
          </Card>
        </Col>
        <Col xs={24} lg={12}>
          <Card title="Resource Utilization" bordered={false}>
            <Paragraph>Resource utilization metrics would appear here.</Paragraph>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default ExecutiveDashboard;
